import { HttpMethod } from "../types/index.js";
export default function (provider) {
  return {
    addAppToFavorite(id) {
      return provider.send(`/apps/${id}/favorite`, HttpMethod.POST);
    },

    codes(code) {
      return provider.send(`/codes/${code}`, HttpMethod.GET);
    },

    createUser(body) {
      return provider.send("/users", HttpMethod.POST, body);
    },

    getBlockingUsers() {
      return provider.send("/blocking_users", HttpMethod.GET);
    },

    getFriends() {
      return provider.send("/friends", HttpMethod.GET);
    },

    getMe() {
      return provider.send("/me", HttpMethod.GET);
    },

    getUser(id) {
      return provider.send(`/users/${id}`, HttpMethod.GET);
    },

    getUserFavoriteApps(id) {
      return provider.send(`/users/${id}/apps/favorite`, HttpMethod.GET);
    },

    getUsers(body) {
      return provider.send("/users/fetch", HttpMethod.POST, body);
    },

    removeAppFromFavorite(id) {
      return provider.send(`/apps/${id}/unfavorite`, HttpMethod.POST);
    },

    searchUser(str) {
      return provider.send(`/search/${str}`, HttpMethod.GET);
    },

    updateProfile(opts) {
      return provider.send("/me", HttpMethod.POST, opts);
    },

    updateRelationship(body) {
      return provider.send("/relationships", HttpMethod.POST, body);
    }

  };
}